<template>
  <section v-if="hasPermissions(['QC-Inspection-Surveys Read', 'QC-Inspection-Surveys Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Surveys. Create a new survey by clicking "Add Survey". Name the Survey, fill in a Subject for the email, and enter the text for the body of the email.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar" v-if="surveys.length && hasPermissions(['QC-Inspection-Surveys Read'])">
                <div class="input-field my-0" >
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button v-if="hasPermissions(['QC-Inspection-Surveys Write'])" class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['QC-Inspection-Surveys Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="surveys.length && hasPermissions(['QC-Inspection-Surveys Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="surveys"
                                :search="search"
                                :checkable="true"
                                :link="'/qc-surveys/'"
                                :linkExt="'/qc-survey-responses/'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
          @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Survey'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Survey Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb           from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from '@/components/WaitingModal'
import Resources            from './resources'
import FormModal            from './FormModal'
import UpdateModal          from './UpdateModal'
import DeletionModal        from '@/components/DeletionModal'
import DinamicTable         from '@/components/DinamicTable'
import DeletionMassiveModal from '@/components/DeletionMassiveModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'Survey',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        DeletionMassiveModal,
        DinamicTable,
        UnauthorizedComponent
    },
    
    data() 
    {
        return {
            notyf,
            user:            this.get_user(),
            child_href:      '/qc-surveys-detail/',
            title_page:      'Surveys',
            rest_api:        `surveys`,
            table_headers:   Resources.table_headers,
            breadcrumb:      Resources.breadcrumb,
            add_btn:         'Add Survey',
            single_select:   false,
            table_selection: [],
            search:          '',
            global_index:    '',
            single_object:   {},
            surveys:         [],
            array_options:   {},
            select_ids:      [],
        }
    },

    methods: 
    {

        unshift_object(new_object)
        {
            this.surveys.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.surveys.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.surveys[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = {...this.surveys[index]}
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            let surveys_data = data.surveys

            this.array_options['question_type_id'] = data.question_types

            this.surveys = surveys_data
            
        },

        trashing(index)
        {
            this.surveys.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.surveys.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids: this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                const index = this.surveys.findIndex(value => value.id == item)
                if(index > -1)
                {
                    this.surveys.splice(index, 1)
                }
                })
                this.select_ids = []
            }
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['QC-Inspection-Surveys Read']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.surveys.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },

}

</script>